"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var FullJitterBackoff_1 = require("../backoff/FullJitterBackoff");
var CSPMonitor_1 = require("../cspmonitor/CSPMonitor");
var Message_1 = require("../message/Message");
var DefaultReconnectController_1 = require("../reconnectcontroller/DefaultReconnectController");
var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");
var DefaultSigV4_1 = require("../sigv4/DefaultSigV4");
var DefaultWebSocketAdapter_1 = require("../websocketadapter/DefaultWebSocketAdapter");
var WebSocketReadyState_1 = require("../websocketadapter/WebSocketReadyState");
var PrefetchOn_1 = require("./PrefetchOn");
var DefaultMessagingSession = /*#__PURE__*/function () {
  function DefaultMessagingSession(configuration, logger, webSocket, reconnectController, sigV4) {
    _classCallCheck(this, DefaultMessagingSession);
    this.configuration = configuration;
    this.logger = logger;
    this.webSocket = webSocket;
    this.reconnectController = reconnectController;
    this.sigV4 = sigV4;
    this.observerQueue = new Set();
    this.isConnecting = false;
    if (!this.webSocket) {
      this.webSocket = new DefaultWebSocketAdapter_1.default(this.logger);
    }
    if (!this.reconnectController) {
      this.reconnectController = new DefaultReconnectController_1.default(configuration.reconnectTimeoutMs, new FullJitterBackoff_1.default(configuration.reconnectFixedWaitMs, configuration.reconnectShortBackoffMs, configuration.reconnectLongBackoffMs));
    }
    if (!this.sigV4) {
      this.sigV4 = new DefaultSigV4_1.default(this.configuration.chimeClient, this.configuration.awsClient);
    }
    CSPMonitor_1.default.addLogger(this.logger);
    CSPMonitor_1.default.register();
  }
  _createClass(DefaultMessagingSession, [{
    key: "addObserver",
    value: function addObserver(observer) {
      this.logger.info('adding messaging observer');
      this.observerQueue.add(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.logger.info('removing messaging observer');
      this.observerQueue.delete(observer);
    }
  }, {
    key: "start",
    value: function start() {
      if (this.isClosed() && !this.isConnecting) {
        this.startConnecting(false);
      } else {
        this.logger.info('messaging session already started');
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.isClosed()) {
        this.isClosing = true;
        this.webSocket.close();
        CSPMonitor_1.default.removeLogger(this.logger);
      } else {
        this.logger.info('no existing messaging session needs closing');
      }
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(observerFunc) {
      var _this = this;
      var _iterator = _createForOfIteratorHelper(this.observerQueue),
        _step;
      try {
        var _loop = function _loop() {
          var observer = _step.value;
          AsyncScheduler_1.default.nextTick(function () {
            if (_this.observerQueue.has(observer)) {
              observerFunc(observer);
            }
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "setUpEventListeners",
    value: function setUpEventListeners() {
      var _this2 = this;
      this.webSocket.addEventListener('open', function () {
        _this2.openEventHandler();
      });
      this.webSocket.addEventListener('message', function (event) {
        _this2.receiveMessageHandler(event.data);
      });
      this.webSocket.addEventListener('close', function (event) {
        _this2.closeEventHandler(event);
      });
      this.webSocket.addEventListener('error', function () {
        _this2.logger.error("WebSocket error");
      });
    }
  }, {
    key: "startConnecting",
    value: function startConnecting(reconnecting) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var endpointUrl, endpoint, closeEvent, signedUrl;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.isConnecting = true;
              _context.prev = 1;
              if (!reconnecting) {
                this.reconnectController.reset();
              }
              if (this.reconnectController.hasStartedConnectionAttempt()) {
                this.reconnectController.startedConnectionAttempt(false);
              } else {
                this.reconnectController.startedConnectionAttempt(true);
              }
              // reconnect needs to re-resolve endpoint url, which will also refresh credentials on client if they are expired.
              endpointUrl = !reconnecting ? this.configuration.endpointUrl : undefined;
              if (!(endpointUrl === undefined)) {
                _context.next = 18;
                break;
              }
              _context.prev = 6;
              _context.next = 9;
              return this.configuration.chimeClient.getMessagingSessionEndpoint().promise();
            case 9:
              endpoint = _context.sent;
              endpointUrl = endpoint.Endpoint.Url;
              _context.next = 18;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](6);
              closeEvent = new CloseEvent('close', {
                wasClean: false,
                code: 4999,
                reason: 'Failed to getMessagingSessionEndpoint',
                bubbles: false
              });
              this.closeEventHandler(closeEvent);
              return _context.abrupt("return");
            case 18:
              signedUrl = this.prepareWebSocketUrl(endpointUrl);
              this.logger.info("opening connection to ".concat(signedUrl));
              this.webSocket.create(signedUrl, [], true);
              this.forEachObserver(function (observer) {
                if (observer.messagingSessionDidStartConnecting) {
                  observer.messagingSessionDidStartConnecting(reconnecting);
                }
              });
              this.setUpEventListeners();
            case 23:
              _context.prev = 23;
              this.isConnecting = false;
              return _context.finish(23);
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1,, 23, 26], [6, 13]]);
      }));
    }
  }, {
    key: "prepareWebSocketUrl",
    value: function prepareWebSocketUrl(endpointUrl) {
      var queryParams = new Map();
      queryParams.set('userArn', [this.configuration.userArn]);
      queryParams.set('sessionId', [this.configuration.messagingSessionId]);
      if (this.configuration.prefetchOn === PrefetchOn_1.default.Connect) {
        queryParams.set('prefetch-on', [PrefetchOn_1.default.Connect]);
      }
      return this.sigV4.signURL('GET', 'wss', 'chime', endpointUrl, '/connect', '', queryParams);
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this.webSocket.readyState() === WebSocketReadyState_1.default.None || this.webSocket.readyState() === WebSocketReadyState_1.default.Closed;
    }
  }, {
    key: "openEventHandler",
    value: function openEventHandler() {
      this.reconnectController.reset();
      this.isSessionEstablished = false;
    }
  }, {
    key: "receiveMessageHandler",
    value: function receiveMessageHandler(data) {
      try {
        var jsonData = JSON.parse(data);
        var messageType = jsonData.Headers['x-amz-chime-event-type'];
        var message = new Message_1.default(messageType, jsonData.Headers, jsonData.Payload || null);
        if (!this.isSessionEstablished && messageType === 'SESSION_ESTABLISHED') {
          // Backend connects WebSocket and then either
          // (1) Closes with WebSocket error code to reflect failure to authorize or other connection error OR
          // (2) Sends SESSION_ESTABLISHED. SESSION_ESTABLISHED indicates that all messages and events on a channel
          // the app instance user is a member of is guaranteed to be delivered on this WebSocket as long as the WebSocket
          // connection stays opened.
          this.forEachObserver(function (observer) {
            if (observer.messagingSessionDidStart) {
              observer.messagingSessionDidStart();
            }
          });
          this.isSessionEstablished = true;
        } else if (!this.isSessionEstablished) {
          // SESSION_ESTABLISHED is not guaranteed to be the first message, and in rare conditions a message or event from
          // a channel the member is a member of might arrive prior to SESSION_ESTABLISHED.  Because SESSION_ESTABLISHED indicates
          // it is safe to bootstrap the user application with out any race conditions in losing events we opt to drop messages prior
          // to SESSION_ESTABLISHED being received
          return;
        }
        this.forEachObserver(function (observer) {
          if (observer.messagingSessionDidReceiveMessage) {
            observer.messagingSessionDidReceiveMessage(message);
          }
        });
      } catch (error) {
        this.logger.error("Messaging parsing failed: ".concat(error));
      }
    }
  }, {
    key: "retryConnection",
    value: function retryConnection() {
      var _this3 = this;
      return this.reconnectController.retryWithBackoff(function () {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.startConnecting(true);
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
      }, null);
    }
  }, {
    key: "closeEventHandler",
    value: function closeEventHandler(event) {
      this.logger.info("WebSocket close: ".concat(event.code, " ").concat(event.reason));
      if (event.code !== 4999) {
        this.webSocket.destroy();
      }
      if (!this.isClosing && this.canReconnect(event.code) && this.retryConnection()) {
        return;
      }
      this.isClosing = false;
      if (this.isSessionEstablished) {
        this.forEachObserver(function (observer) {
          if (observer.messagingSessionDidStop) {
            observer.messagingSessionDidStop(event);
          }
        });
      }
    }
  }, {
    key: "canReconnect",
    value: function canReconnect(closeCode) {
      // 4003 is Kicked closing event from the back end
      return closeCode === 1001 || closeCode === 1006 || closeCode >= 1011 && closeCode <= 1014 || closeCode > 4000 && closeCode !== 4002 && closeCode !== 4003 && closeCode !== 4401;
    }
  }]);
  return DefaultMessagingSession;
}();
exports.default = DefaultMessagingSession;